var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');

var SodData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);
};

lib_core.inherit(SodData, DualRowPackageData);
lib_core.JsonParser.registerClass(SodData, "SodData");

module.exports = SodData;

SodData.prototype.getSilkscreen = function(pads) {
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    //get body dimesnsions depending on mapping type of silkscreen to body
    var body = this.getBodyForSilkscreen();
    var leftPad = pads[0],
        rightPad = pads[1];

    //TODO: move silkscreen up for larger right pad height
    var lineStartX = leftPad.getPos().x - leftPad.getTopCopper().width() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2;
    var pathData;

    //if pad top edge with silkscreen clearance and silkscreen stroke width is above assembly outline top edge draw top and bottom silkscreen with silkscreenClearance
    //right pad is used for SODFL package to move silkscreen in vertical direction
    if (rightPad.getPos().y + rightPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
        var topLinePosY = rightPad.getPos().y + rightPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2;
        var bottomLinePosY = rightPad.getPos().y - rightPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2;

        pathData = new PathData(new lib_geometry.Coord(body.width / 2, topLinePosY), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, topLinePosY), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, bottomLinePosY), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, bottomLinePosY), PathType.LINE));
    } else {
        pathData = new PathData(new lib_geometry.Coord(body.width / 2, body.height / 2), IPCRules.silkscreenStrokeWidth);
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, body.height / 2), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, -body.height / 2), PathType.LINE));
        pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, -body.height / 2), PathType.LINE));
    }

    silkscreen.push(pathData);

    return silkscreen;
};
